<template>
    <table class="table" style="background-color: rgba(0, 0, 0, 0.0); color: white; border: none;">
        <tr>
            <td width="5%">
            </td>
            <td><h1 v-html="name"></h1></td>
        </tr>
        <tr>
            <td>
                <div class="block">
                    <b-icon
                        icon="account"
                        size="is-medium">
                    </b-icon>
                </div>
            </td>
            <td><h2 v-html="about"></h2></td>
        </tr>
        <tr>
            <td></td>
            <td>
                <ul style="font-size: 18px;">
                <li>Bachelor of Science in Accountancy from<b-tooltip label="Arizona State University"  position="is-right">
                        <span style="margin-left: 10px;">ASU</span>
                    </b-tooltip>
                        - 2011<br />
                    <b-tooltip label="with the highest distinction"  position="is-right">
                        <span style="margin-left: 10px;">Graduated Summa Cum Laude</span>
                    </b-tooltip>
                </li>
                <li>Master of Accountancy (MACC) from<b-tooltip label="Arizona State University"  position="is-right">
                    <span style="margin-left: 10px;">ASU</span>
                </b-tooltip> - 2012</li>
                <li>Work in Public Accounting Field - Since 2012</li>
                <li>Teach IRS Financial &amp; Tax Series - Since 2015</li>
                </ul>
            </td>
        </tr>
        <tr>
            <td>
                <div class="block">
                    <b-icon
                        icon="briefcase-variant"
                        size="is-medium">
                    </b-icon>
                </div>
            </td>
            <td><h2>{{ work }}</h2></td>
        </tr>
        <tr>
            <td>
                <div class="block">
                    <b-icon
                        icon="mailbox"
                        size="is-medium">
                    </b-icon>
                </div>
            </td>
            <td><h2>{{ address1 }}</h2></td>
        </tr>
        <tr>
            <td></td>
            <td><h2>{{ address2 }}</h2></td>
        </tr>
        <tr>
            <td>
                <div class="block">
                    <b-icon
                        icon="phone-classic"
                        size="is-medium">
                    </b-icon>
                </div>
            </td>
            <td><h2>{{ phone1 }} - {{ phone2 }}</h2></td>
        </tr>
        <tr>
            <td>
                <div class="block">
                    <b-icon
                        icon="email"
                        size="is-medium">
                    </b-icon>
                </div>
            </td>
            <td><h2>{{ email }}</h2></td>
        </tr>
    </table>
</template>

<script>
export default {
    name: 'profile',
    data () {
        return {
            name: 'Dai Hua, MACC LLC',
            about: 'About the Owner',
            work: 'Accounting and Tax Services',
            address1: '2390 E. Camelback Road, Suite 130',
            address2: 'Phoenix, AZ 85016',
            phone1: '(602) 456-2DAI',
            phone2: '(602) 456-2324',
            email:  'Dai@daihuamacc.com',
            website: 'www.daihuamacc.com',
        }
    }
}
</script>


// WEBPACK FOOTER //
// Profile.vue?345e4b6a